import React from 'react';
import head from 'lodash.head';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import { generateReactKey } from '../../../../utils/shared/commonUtils';
import { PERIOD, TITLE } from '../../../../constants/shared/CommonConstants';

const splitSkillTitle = skillName => skillName.trim().split(' ');

const SkillNamesHeader = ({ skills, classNameCell }) =>
    skills.map(({ name, title }, index) => {
        const skillTitles = splitSkillTitle(title);
        const skillTitle = head(skillTitles);
        const skillSubtitle = skillTitles.slice(1).join(' ');

        return (
            <div key={generateReactKey(index)} className={classNameCell}>
                <div>{skillTitle}</div>
                {skillSubtitle}
                <span className="skill-name">{name !== title && name}</span>
            </div>
        );
    });

const PeriodsHeader = ({ toyPeriods, classNameCell, summerPeriodLabel }) => {
    const periodTitleMapper = {
        [PERIOD.BOY]: () => (
            <div key={PERIOD.BOY} className={classNameCell}>
                Beginning
                <br />
                of Year
            </div>
        ),
        [PERIOD.MOY]: () => (
            <div key={PERIOD.MOY} className={classNameCell}>
                Middle
                <br />
                of Year
            </div>
        ),
        [PERIOD.EOY]: () => (
            <div key={PERIOD.EOY} className={classNameCell}>
                End
                <br />
                of Year
            </div>
        ),
        [PERIOD.SUMMER]: () => (
            <div key={PERIOD.SUMMER} className={classNameCell}>
                {summerPeriodLabel}
            </div>
        ),
    };
    return toyPeriods.map(period => {
        return periodTitleMapper[period]();
    });
};

const HeaderRow = ({ skills, classNameCell, toyPeriods, summerPeriodLabel }) => (
    <div className="header-row row">
        <div className={`${classNameCell} empty-cell`} />
        {isNil(skills) ? (
            <PeriodsHeader
                toyPeriods={toyPeriods}
                classNameCell={classNameCell}
                summerPeriodLabel={summerPeriodLabel}
            />
        ) : (
            <SkillNamesHeader skills={skills} classNameCell={classNameCell} />
        )}
    </div>
);

SkillNamesHeader.propTypes = {
    skills: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PeriodsHeader.defaultProps = {
    classNameCell: '',
    toyPeriods: [],
};

PeriodsHeader.propTypes = {
    classNameCell: PropTypes.string,
    toyPeriods: PropTypes.array,
};

HeaderRow.defaultProps = {
    classNameCell: '',
    skills: [],
    toyPeriods: [],
    summerPeriodLabel: TITLE.SUMMER_TITLE,
};

HeaderRow.propTypes = {
    classNameCell: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.object),
    toyPeriods: PropTypes.array,
    summerPeriodLabel: PropTypes.string,
};

export default HeaderRow;
